var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgClose = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.261088 12.466L5.71859 6.99845L0.261088 1.54095C-0.0819663 1.1979 -0.0819663 0.622777 0.261088 0.269632C0.604143 -0.0936024 1.18935 -0.0835126 1.5425 0.269632L7 5.72713L12.4575 0.269632C12.8006 -0.0835126 13.3757 -0.0835126 13.7389 0.269632C14.0921 0.612687 14.082 1.1979 13.7389 1.54095L8.27132 6.99845L13.7389 12.466C14.082 12.8091 14.082 13.3842 13.7389 13.7374C13.3858 14.0905 12.8006 14.0804 12.4575 13.7374L7 8.27986L1.5425 13.7374C1.18935 14.0804 0.614233 14.0804 0.261088 13.7374C-0.0920561 13.3943 -0.0819663 12.8091 0.261088 12.466Z",
    fill: "#414141"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgClose);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Close.2e2ec530fafd947f5f3a34d6a4098832.svg";